export default "__VITE_ASSET__ChnM0OEV__"